import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DownloadedMobileNumber = () => {
  const [rowData, setRowData] = useState([]);
  const [columnDefs] = useState([
    { headerName: "SlNo", valueGetter: "node.rowIndex + 1", width: 100 },
    { headerName: "Name", field: "name", sortable: true, filter: true },
    { headerName: "Type", field: "type", sortable: true, filter: true },
    { headerName: "Mobile No", field: "mobileno", sortable: true, filter: true },
  ]);

  useEffect(() => {
    fetchData();
  }, []);


  
      
              useEffect(() => {
              document.title = 'Downloaded Mobile Number - Calendar Services';
           }, []);
  



  const fetchData = async () => {
    try {
      const response = await axios.post("http://localhost:3036/api/registration", {

        // const response = await axios.post(`${API_BASE_URL}/api/registration`, {

        isExport: 1, // Include the isExport parameter
      });
      setRowData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onExportClick = () => {
    if (window.confirm("Are you sure to export data?")) {
      gridApi.exportDataAsCsv({ fileName: "downloaded_mobile_number.csv" });
    }
  };

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  return (
    <div className="max-w-6xl mx-auto mt-8 bg-white">

      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          padding: "0 10%",
        }}
      >
        <h2  className="text-2xl font-bold mb-6 text-center" style={{ textAlign: "center" }}>
        Mobile Number
      </h2>
        {/* <button
    className="bg-green-500 text-white px-4 py-2 rounded-md"
    onClick={onExportClick}
          style={{ marginBottom: "50px", display: "flex", justifyContent: "space-between", alignItems: "center" }}        >
          Export to Excel
        </button> */}
      </div>


      <div className="table-responsive" style={{ marginBottom: "50px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <div></div> {/* This is a placeholder for table alignment */}
  <button
    className="bg-green-500 text-white px-4 py-2 rounded-md"
    onClick={onExportClick}  >
    Export to Excel
  </button>
</div>

      {/* Grid Section */}
      <div
        className="ag-theme-alpine"
        style={{ height: 600, width: "65%", margin: "auto" }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={true}
          paginationPageSize={100}
          onGridReady={onGridReady}
        />
      </div>
    </div>
  );
};

export default DownloadedMobileNumber;
